import React from 'react';
import style from './Onion.module.scss'

export const Onion = () => {
	return (
		<svg
      className={style.onion}
			viewBox='0 0 1024 1024'
			version='1.1'
		>
			<path
				d='M330.51648 128.55296l23.27552-23.2704 174.6176 174.6176-23.2704 23.27552z'
				fill='#84B857'
			/>
			<path
				d='M656.31744 105.27232l23.27552 23.2704-174.59712 174.6432-23.27552-23.26528z'
				fill='#84B857'
			/>
			<path
				d='M491.03872 105.29792h32.91648v246.95296h-32.91648z'
				fill='#639635'
			/>
			<path d='M502.11328 846.4896h8.57088v66.66752h-8.57088z' fill='#601986' />
			<path
				d='M504.60672 860.01152l6.06208 6.05696-47.13472 47.1552-6.06208-6.05696z'
				fill='#601986'
			/>
			<path
				d='M499.44064 866.01728l6.06208-6.05184 47.09888 47.17568-6.0672 6.05696z'
				fill='#601986'
			/>
			<path
				d='M902.43072 571.37152c0 166.28224-134.78912 301.07136-301.07136 301.07136h-188.5696c-166.27712 0-301.07136-134.78912-301.07136-301.07136 0-166.27712 134.79424-301.07136 301.07136-301.07136h188.5696c166.28224 0 301.07136 134.79424 301.07136 301.07136z'
				fill='#9F4B98'
			/>
			<path
				d='M507.07968 270.21312C375.1936 306.92864 278.38464 427.8272 278.38464 571.4176c0 143.58528 96.81408 264.48896 228.69504 301.20448 131.88096-36.71552 228.69504-157.6192 228.69504-301.20448-0.00512-143.58528-96.81408-264.48896-228.69504-301.20448z'
				fill='#D2AED1'
			/>
			<path
				d='M412.68736 571.67872c0 111.8976 34.94912 215.58272 94.39744 300.94336 59.43808-85.36064 94.39232-189.04576 94.39232-300.94336s-34.94912-215.58784-94.39232-300.9536c-59.44832 85.36576-94.39744 189.056-94.39744 300.9536z'
				fill='#FFFEFE'
			/>
		</svg>
	)
}
